import PlusOutlined from '@ant-design/icons/PlusOutlined';
import Dropdown from 'antd/es/dropdown';
import React from 'react';

import type { FilterConfig } from '../DataTable/DataTable.types';
import {
  AddFilterButton,
  FilterDropdownContent,
  FilterOptionButton,
} from './FilterBar.styles';

interface FilterDropdownProps {
  availableFilters: FilterConfig[];
  onFilterSelect: (filter: FilterConfig) => void;
}

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
  availableFilters,
  onFilterSelect,
}) => {
  if (availableFilters.length === 0) {
    return null;
  }

  const dropdownContent = (
    <FilterDropdownContent>
      {availableFilters.map((filter) => (
        <FilterOptionButton
          key={filter.key}
          onClick={() => onFilterSelect(filter)}
          size="small"
        >
          {filter.label}
        </FilterOptionButton>
      ))}
    </FilterDropdownContent>
  );

  return (
    <Dropdown
      popupRender={() => dropdownContent}
      trigger={['click']}
      placement="bottomLeft"
    >
      <AddFilterButton icon={<PlusOutlined />} size="small">
        Add Filter
      </AddFilterButton>
    </Dropdown>
  );
};
